<ng-container>
  <section class="storyblok-blok-container">
    <div
      class="rich-content-wrapper-container"
      [ngClass]="{ 'rich-content-wrapper-container__white-background': !isContentLandingPage }"
    >
      <app-rich-content class="rich-content-wrapper" [content]="content.value" [showParagraphMargin]="true">
      </app-rich-content>
    </div>
  </section>
</ng-container>
